module.exports = __webpack_public_path__ + "img/DesertShot1.7769d92b.png";